"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreFunctions = void 0;
var CoreFunctions = /** @class */ (function () {
    function CoreFunctions() {
    }
    CoreFunctions.isNil = function (value) {
        return value === null || value === undefined;
    };
    CoreFunctions.isNumeric = function (value) {
        // parseFloat NaNs numeric-cast false positives (null|true|false|"")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        // adding 1 corrects loss of precision from parseFloat (#15100)
        return !Array.isArray(value) && value - parseFloat(value) + 1 >= 0;
    };
    CoreFunctions.isString = function (value) {
        return typeof value === 'string';
    };
    CoreFunctions.isArray = function (value) {
        return Array.isArray(value);
    };
    CoreFunctions.isObject = function (value) {
        return value instanceof Object && value.constructor === Object;
    };
    CoreFunctions.removeNilProperties = function (obj) {
        var newObj = {};
        Object.keys(obj).forEach(function (key) {
            if (!CoreFunctions.isNil(obj[key])) {
                newObj[key] = obj[key];
            }
        });
        return newObj;
    };
    CoreFunctions.flatten = function (object, prefix) {
        if (prefix === void 0) { prefix = ''; }
        if (CoreFunctions.isNil(object) || CoreFunctions.isString(object) || CoreFunctions.isNumeric(object)) {
            return object;
        }
        return Object.keys(object).reduce(function (prev, element) {
            var _a;
            return object[element] && typeof object[element] === 'object' && !Array.isArray(element)
                ? __assign(__assign({}, prev), CoreFunctions.flatten(object[element], "".concat(prefix).concat(element, "."))) : __assign(__assign({}, prev), (_a = {}, _a["".concat(prefix).concat(element)] = String(object[element]), _a));
        }, {});
    };
    CoreFunctions.getUuidWithDashes = function (uuid) {
        return uuid
            ? uuid.substr(0, 8) +
                '-' +
                uuid.substr(8, 4) +
                '-' +
                uuid.substr(12, 4) +
                '-' +
                uuid.substr(16, 4) +
                '-' +
                uuid.substr(20)
            : null;
    };
    CoreFunctions.newUuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    return CoreFunctions;
}());
exports.CoreFunctions = CoreFunctions;
